<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">お問い合わせ管理</li>
            </ol>
        </nav>
        <div class="container p-0">
            <legend>
                <button type="button" class="btn btn-outline-secondary btn-sm" @click="load()">
                    <i class="fas fa-sync-alt"></i>
                </button>
            </legend>
            <div class="sticky">
                <page :last_page="tickets.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div class="my-2" v-if="tickets.total">
                <div class="card" v-for="t in tickets.data" :key="t.id">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <div :class="{closed: t.closed_at}">
                            <router-link :to="`/admin/ticket/${t.id}`">{{t.ticket_subject.subject}}</router-link>
                            <span class="badge badge-primary badge-pill" v-if="t.ticket_topics_count">
                                {{t.ticket_topics_count}}
                                件の返信
                            </span>
                        </div>
                        <span class="badge badge-secondary badge-pill" v-if="t.closed_at">
                            {{$filters.fromNow(t.closed_at )}} にクローズ
                        </span>
                    </div>
                    <div class="card-body">
                        <editor :content="$filters.jsonParse(t.topic)"
                            :id="'editor-' + t.id"
                            :readOnly="true"
                            :minHeight="0"></editor>
                    </div>
                    <div class="card-footer text-right small">
                        <ul class="horizontal-list">
                            <li v-if="t.user">{{t.user.name}}</li>
                            <li>{{$filters.dateFormat(t.created_at , 'LLLL')}}</li>
                            <li v-if="t.closed_at">{{$filters.dateFormat(t.closed_at , 'LLLL')}}にクローズ</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="nothing" v-else>
                お問い合わせはありません。
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped>
.card {
    margin: 2rem 0;
}
.nothing {
    margin: 2rem 0;
    padding: 5rem 0;
    text-align: center;
    border-radius: .5rem;
}
.closed {
    text-decoration: line-through;
}
</style>

<script>
import page from "components/Page";
export default {
    components: {
        page
    },
    data() {
        return {
            page: 1,
            tickets: {},
            isLoading: false,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        load() {
            this.isLoading = true;
            axios.get("/admin/tickets/get", {params: {page: this.page}}).then(res => {
                this.tickets = res.data;
            }).catch(err => { alert.err(err.response) }).finally(() => {this.isLoading = false});
        }
    },
    mounted() {
        this.load();
    }
}
</script>